import React from "react";

export const Table2ColumnsIcon = ({
  width = 16,
  height = 16,
  color = "#A4A3B1",
}) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      d="M3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4Z"
      stroke={color}
      strokeWidth="1.5"
    ></path>
    <path d="M3 16.5H21" stroke={color} strokeWidth="1.5"></path>
    <path d="M3 12H21" stroke={color} strokeWidth="1.5"></path>
    <path d="M21 7.5H3" stroke={color} strokeWidth="1.5"></path>
    <path d="M12 21V3" stroke={color} strokeWidth="1.5"></path>
  </svg>
);
